export default __webpack_public_path__ + "static/media/apple-iPad10.c0a3488b.jpg";